import React from "react";
import PriceTag from "images/design-system-svgs/pricetag.svg";
import { useAppSelector } from "../../../../../../util/store-types";
import flagsAndExperimentsNames from "constants/flags-and-experiments-names";
import { shouldExcludePromo } from "helpers/product-drawer-helper";

const BuyPromoBanner = () => {
  const promoSkinny = useAppSelector(state => state.smartComponentState?.PDPContent?.data?.buy?.skinny);
  const staticProduct = useAppSelector(state => state.staticProduct);
  const promoExclusionFlag = useAppSelector(
    state => state.flagsAndExperiments?.[flagsAndExperimentsNames.CATALOG_SERVICES_SHOW_PROMO_EXCLUSION]
  );

  const excludePromo = shouldExcludePromo({
    product: staticProduct,
    promoExclusionFlag: Boolean(promoExclusionFlag),
  });

  if (!promoSkinny || excludePromo) {
    return null;
  }

  return (
    <div
      className="flex items-center mb-1 pl-3 pr-4 py-1 rounded-full text-sm bg-lightTealGreen"
      data-test-id="buy-promo-banner">
      <PriceTag className="shrink-0" />
      <div className="ml-3">
        <p className="whitespace-pre-line">{promoSkinny}</p>
      </div>
    </div>
  );
};

export default BuyPromoBanner;
